import MutableTrack from './MutableTrack.js';
import StepData from 'pattern/StepData.js';
import Sample from 'repos/Sample.js';
import Resolution from 'engine/Resolution.js';

const METRONOME_ID = 'QmfJwbUmKMiE1Mrme2xHpHUJP2bVM3BFeUtzQgpDqHssCw';
const RESOLUTION_4 = new Resolution(4, false);

export default class MetronomeTrack extends MutableTrack {
    constructor(sequencerEngine, mixSession, numberOfPatterns, update, skipInit) {
        super(-1, sequencerEngine, mixSession, numberOfPatterns, update, {id: -1});
        this.isMetronome = true;

        if (!skipInit) {
            this.initPattern();
        }
    }

    getCopy(constr=(a,b,c,d,e,f) => new MetronomeTrack(a,b,c,d,true), sequencerEngine=this.sequencerEngine) {
        return super.getCopy(constr, sequencerEngine);
    }

    newFrozenColumn() {}

    dispose() {
        console.log("DISPOSING METRO");
        super.dispose();
    }

    async initPattern() {
        console.log("INIT PATTERN CALLED FOR METRONOME");
        let sample = new Sample(METRONOME_ID);
        await sample.fetchAudio();
        this.addSound(sample);

        let pattern = this.getEasyPattern();
        pattern.addStep(this.getOnBeat(), 0, RESOLUTION_4, 0);
        pattern.addStep(this.getOffBeat(), 1, RESOLUTION_4, 0);
        pattern.addStep(this.getOffBeat(), 2, RESOLUTION_4, 0);
        pattern.addStep(this.getOffBeat(), 3, RESOLUTION_4, 0);

        this.muteableNode.toMaster();

        this.mute(true);
    }

    getOnBeat() {
        let stepData = new StepData();
        stepData.on = true;
        stepData.velocity = 0.7;
        return stepData;
    }

    getOffBeat() {
        let stepData = new StepData();
        stepData.on = true;
        stepData.velocity = 0.2;
        return stepData;
    }

    updateSteps() {
    }

    getUpdateStepsAction() {
        return [];
    }
}
